<template>
    <section class="app">
        <section class="header">
            <div>
                <img src="../../assets/imgs/logo-porto-seco.jpg" height="50">
            </div>
            <div></div>
        </section>
        <section class="body">
            <section class="message">
                <div class="box">
                     <div class="icon">
                        <i class="fal fa-lock-alt"></i>
                    </div>
                    <div class="text">O seu acesso está bloqueado temporariamente.</div>
                    <div class="control">
                        <router-link to="login">Voltar</router-link>
                    </div>
                </div>
            </section>
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg" height="20">
            </div>
        </section>
    </section>
</template>

<script>
    export default {
        name: 'login',
        components: {}
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
